<script>
    import { Link } from '../../utils/split.ts';

    export let info;
</script>

{#if Array.isArray(info)}
    {#each info as item}
        {#if typeof item  == 'number'}
            <a href = {`/${item}`}>{item}</a>
        {:else if item instanceof Link}
            <a href = {item.link}>{item.text}</a>
        {:else}
            <span>{item}</span>
        {/if}
    {/each}
{:else}
    {info}
{/if}